import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import { useSearchParams } from "react-router-dom";

import "./KYCForm.css";

import minusImg from "./../../../../assets/images/minus.png";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Chip from "@mui/material/Chip";
import Personels from "./Personels/Personels.tsx";
import UBOs from "./UBOs/UBOs.tsx";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs, { Dayjs } from "dayjs";
import jwt_decode from "jwt-decode";

import fromImg from "./../../../../assets/icons/forms.png";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import DocumentsUpload from "./DocumentsUpload/HomeCookDocumentUpload.tsx";
import { uploadFiles } from "./../../../../fileUploader/FileUploader.js";
import LoadingView from "./../../../components/LoadingView/LoadingView.js";

function HomeCookKYCForm(props) {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [searchParams, setSearchParams] = useSearchParams();

  const addValue = (props) => {
    console.log(props);
    // setAutoCompleteValue(props)
  };

  const [tableData, setTableData] = useState([]);
  const [kitchenRegistered, setKitchenRegistered] = useState(false);
  const [hygieneCert, setHygieneCert] = useState(false);

  // const dataFromDocument = (props) => {
  //   console.log("43" + props);
  //   setTableData(props);

  // };
  const dataFromDocument = (data) => {
    setTableData(data.tableData);
    setKitchenRegistered(data.kitchenRegistered);
    setHygieneCert(data.hygieneCert);
  };

  // const FileUpload=()=>{
  //     for(let i=0; i<tableData.length; i++){
  //         console.log(tableData[i].file)
  //         uploadFiles(tableData[i].file)
  //         console.log('i'+i)
  //     }
  // }

  const textFieldValue = (props) => {
    console.log(props);
    // setAutoCompleteValue(props)
  };

  const [addDirector, setAddDirector] = React.useState(1);
  const [addUBO, setAddUBO] = React.useState(1);

  const [radiovalue, setRadioValue] = React.useState("No");
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioValue((event.target as HTMLInputElement).value);
    console.log(
      "(event.target as HTMLInputElement).value: " +
      (event.target as HTMLInputElement).value,
    );

    // setitemdata();
  };
  console.log(radiovalue);
  const [trialradiovalue, settrialRadioValue] = React.useState("No");
  const handletrialRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    settrialRadioValue((event.target as HTMLInputElement).value);
    console.log(
      "(event.target as HTMLInputElement).value: " +
      (event.target as HTMLInputElement).value,
    );

    // setitemdata();
  };
  console.log(trialradiovalue);

  const [stockradiovalue, setstockRadioValue] = React.useState("No");
  const handlestockRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setstockRadioValue((event.target as HTMLInputElement).value);
    console.log(
      "(event.target as HTMLInputElement).value: " +
      (event.target as HTMLInputElement).value,
    );

    // setitemdata();
  };
  console.log(stockradiovalue);
  const [profitradiovalue, setprofitRadioValue] = React.useState("No");
  const handleprofitRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setprofitRadioValue((event.target as HTMLInputElement).value);
    console.log(
      "(event.target as HTMLInputElement).value: " +
      (event.target as HTMLInputElement).value,
    );
  };

  const [isOwnAllDomain, setIsOwnAllDomain] = React.useState("No");
  const handleDomainRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsOwnAllDomain((event.target as HTMLInputElement).value);

    // setitemdata();
  };
  console.log(isOwnAllDomain);
  const [directorOne, setdirectorOne] = React.useState({});
  const [directors, setDirectors] = useState([{}]);
  const PersonOneValue = (props) => {
    console.log(props);
    props.rank = 1;
    setdirectorOne(props);
    // setDirectors([...directors, directorOne])
  };
  const [directorTwo, setdirectorTwo] = React.useState({});
  const PersontwoValue = (props) => {
    console.log(props);
    props.rank = 2;
    setdirectorTwo(props);
    //     setDirectors([...directors, directorTwo])
  };
  const [directorThree, setdirectorThree] = React.useState({});
  const PersonThreeValue = (props) => {
    console.log(props);
    props.rank = 3;
    setdirectorThree(props);
    // setDirectors([...directors, directorThree])
  };

  const [uboOne, setuboOne] = React.useState({});
  const [ubos, setUbos] = useState([{}]);
  const uboOneValue = (props) => {
    console.log(props);
    props.rank = 1;
    setuboOne(props);
    setUbos([...ubos, uboOne]);
  };
  const [uboTwo, setuboTwo] = React.useState({});
  const ubotwoValue = (props) => {
    props.rank = 2;
    setuboTwo(props);
    setUbos([...ubos, uboTwo]);
  };
  const [uboThree, setuboThree] = React.useState({});
  const uboThreeValue = (props) => {
    props.rank = 3;
    setuboThree(props);
    setUbos([...ubos, uboThree]);
  };

  //Starting get api
  // const apiAddress = process.env.REACT_APP_SECRET;

  const [dataRows, setDataRows] = React.useState({
    restaurantRegistrationId: "",
    restaurantName: "",
    companyRegistrationNumber: "",
    businessTypeId: "",
    businessTypeDetails: "",
    userId: ""
  });

  const loadData = () => {
    axios
      .get(
        apiAddress + "/api/KYCForm/GetRestaurantName/" + searchParams.get("id"),
      )
      .then((response) => {
        console.log(response.data[0]);
        setDataRows(response.data);
      });
  };

  React.useEffect(() => {
    console.log("first");
    loadData();
    if (props.fillup == "fillup") {
      setMenu(1);
    }
  }, []);

  //Ending get api
  const [tokenData, setTokenData] = useState({});
  useEffect(() => {
    loadTokenData();
  }, []);

  const loadTokenData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) { }
    }
  };
  //post api start

  const [selectedDate, setSelectedDate] = useState("");

  const handleDateChange = (event) => {
    const { value } = event.target;
    setSelectedDate(value);
    console.log(selectedDate);
  };
  console.log(selectedDate);
  var newDate = new Date(selectedDate);
  console.log(newDate);
  //date end

  const restaurantId = searchParams.get("rn");
  const registrationNumber = searchParams.get("cn");
  const typeOfBusiness = searchParams.get("tob");
  const [Obj, setObj] = useState({
    Id: "paymentID",
    KycCompanyDetailsId: "1223",
    SettlementCurrencytype: 2,
    AccountHolder: "",
    ShortCode: "",
    AccountNumber: "",
    IBAN: "123",
    IsActive: false,
    CreationId: "2424",
    CreationDate: new Date(),
    ModifierId: "243214",
    ModificationDate: new Date(),
  });
  const [ObjEUR, setObjEUR] = useState({
    Id: "paymentID",
    KycCompanyDetailsId: "1223",
    SettlementCurrencytype: 1,
    AccountHolder: "",
    ShortCode: "",
    AccountNumber: "",
    IBAN: "",
    IsActive: false,
    CreationId: "2424",
    CreationDate: new Date(),
    ModifierId: "243214",
    ModificationDate: new Date(),
  });
  const [principalPhone, setprincipalPhone] = useState();
  const [principleObj, setPrincipleObj] = useState({
    Id: "principalID",
    KycCompanyDetailsId: "sdfasdf",
    FirstName: "",
    LastName: "",
    EmailAddress: "",
    ConfirmEmail: "",
    PhoneNumber: "",
    CreationId: "12345",
  });
  const [personelList, setPersonelList] = useState([]);
  const [KYCFormView, setKYCFormView] = useState({
    companyDetail: {
      Id: "testID",
      RestaurantId: "",
      LegalNameOFCompany: "N/A",
      RegisteredCountry: "",
      CompanyRegistrationNumber: "N/A",
      State: "",
      TradeName: "",
      City: "",
      TypeOfBusinessId: "",
      HouseNumber: "",
      PhoneNumber: "",
      RegisteredStreetAddress: "",
      VatOrTaxNumber: "N/A",
      Postalcode: "",
      IncorporationDate: new Date(),
      BillingAddress: "",
      CountryCode: "",
      IsListedOnStockExchange: true,
      IsNotForProfitOrg: true,
      LengthOfBusiness: "0",
      Website: "",
      DetailsDescriptionOfProduct: "N/A",
      IsAllDomainOwn: true,
      PrimaryCurrencyTypeId: "N/A",
      ExpectedMonthlyTurnOver: "0.0",
      AvgTransactionValue: "0.0",
      HighestTransactionValue: "0.0",
      HasRecurringPaymentsOffer: true,
      IsOfferTrailPeriods: true,
      ApprovalStatusId: "f07294b7-c94d-4d5e-a064-b1282d5b5434",
      IsActive: false,
      CreationId: "12345",
      CreationDate: new Date(),
      ModifierId: "12233445",
      ModificationDate: new Date(),
    },
  });

  const [value, setValue] = React.useState<Dayjs | null>(dayjs("2022-04-17"));
  var month = parseInt(value.$M + 1);
  var day = value.$y + "-" + month + "-" + value.$D;
  var mydate = new Date(day);

  console.log(mydate);
  //company details validation states start
  const [LegalNamerror, setLegalNamerror] = useState(false);
  const [RegisteredCountry, setRegisteredCountry] = useState(false);
  const [State, setState] = useState(false);
  const [Tradename, setTradename] = useState(false);
  const [City, setCity] = useState(false);
  const [houseNumber, setHouseNumber] = useState(false);
  const [companyDetailsPhone, setCompanyDetailsPhone] = useState(false);
  const [vat, setVat] = useState(false);
  const [ZipCode, setZipCode] = useState(false);
  const [IncorporateDate, setIncorporateDate] = useState(false);
  const [BiilingAddress, setBiilingAddress] = useState(false);
  const [ReegisteredStreet, setRegisteredStreet] = useState(false);
  const [CountryCode, setCountryCode] = useState(false);
  const [LengthOfBusiness, setLengthOfBusiness] = useState(false);
  const [Website, setWebsite] = useState(false);
  const [DetailsDescription, setDetailsDescription] = useState(false);
  const [PrimaryCurrenry, setPrimaryCurrenry] = useState(false);
  const [MonthlyTurnover, setMonthlyTurnover] = useState(false);
  const [AvgTransaction, setAvgTransaction] = useState(false);
  const [HigestTransaction, setHigestTransaction] = useState(false);

  //payment acceptance details start
  const [AccountholderGBP, setAccountholderGBP] = useState(false);
  const [Sortcode, setSortcode] = useState(false);
  const [AccountNumber, setAccountNumber] = useState(false);
  const [AccountholderEUR, setAccountholderEUR] = useState(false);
  const [Ibn, setIbn] = useState(false);

  //principal contact start
  const [FirstName, setFirstName] = useState(false);
  const [lastname, setlastname] = useState(false);
  const [Email, setEmail] = useState(false);
  const [ConfirmEmail, setConfrimEmail] = useState(false);
  const [PhonenNumber, setPhonenNumber] = useState(false);

  //principal contact end

  //company details validation states end
  // function uploadFiles(filesData) {

  //     var data = "";

  //     filesData.map((dt, index) => {
  //         console.log(dt);

  //         dt.File.map((data,i)=>{
  //             const formData = new FormData();
  //             formData.append('file', data);
  //             axios({
  //                 method: 'post',
  //                 url: apiAddress + '/api/FileUpload/addfile',
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data' // <- HERE
  //                 },
  //                 data: formData
  //             })
  //             .then((response)=>{
  //                 console.log(response)

  //             })
  //         })

  //         // axios({
  //         //     method: 'post',
  //         //     url: apiAddress + '/api/KYCForm/postDocuments',
  //         //     headers: {
  //         //         'Content-Type': 'multipart/form-data' // <- HERE
  //         //     },
  //         //     data: dt
  //         // })
  //             // .then((response) => {
  //             //     console.log(response)
  //             //     data = response.data.url;
  //             // })
  //             // .catch((error) => {
  //             //     console.log(error);

  //             // });
  //     })

  //     return data

  // }
  const test = async (props) => {
    await axios({
      method: "post",
      url: apiAddress + "/api/KYCForm/postDocuments",
      data: props,
    })
      .then((response) => {
        console.log(response);

        SetloadingModal(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fileupload = async (id) => {
    console.log(id);
    for (var i = 0; i < tableData.length; i++) {
      //  var urls =await uploadFiles(tableData[i].File);
      // //  console.log(urls)

      tableData[i].KycCompanyDetailsId = id;
      //  tableData[i].FilesUrl=urls;

      var data = [];

      const formData = new FormData();
      console.log(tableData[i].File.length);

      tableData[i].File.forEach((file) => {
        formData.append("file", file);
      });
      await axios({
        method: "post",
        url: apiAddress + "/api/FileUpload/addMultiplefile_Document",
        headers: {
          "Content-Type": "multipart/form-data", // <- HERE
        },
        data: formData,
      })
        .then((response) => {
          tableData[i].FilesUrl = response.data;
          console.log(response);
          // data.push( response.data);
          // console.log(response.data)
          test(tableData[i]);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    console.log(tableData);
    return tableData;
  };

  const submitData = () => {
    //compnaydetails validation start

    var valid = true;

    if (KYCFormView.companyDetail.RegisteredCountry.trim() === "") {
      setRegisteredCountry(true);
      valid = false;
    }
    // if (KYCFormView.companyDetail.State.trim() === "") {
    //   setState(true);
    //   valid = false;
    // }
    if (KYCFormView.companyDetail.TradeName.trim() === "") {
      setTradename(true);
      valid = false;
    }
    if (KYCFormView.companyDetail.City.trim() === "") {
      setCity(true);
      valid = false;
    }
    if (KYCFormView.companyDetail.HouseNumber.trim() === "") {
      setHouseNumber(true);
      valid = false;
    }
    if (KYCFormView.companyDetail.PhoneNumber.trim() === "") {
      setCompanyDetailsPhone(true);
      valid = false;
    }
    if (KYCFormView.companyDetail.Postalcode.trim() === "") {
      setZipCode(true);
      valid = false;
    }
    if (KYCFormView.companyDetail.CountryCode.trim() === "") {
      setCountryCode(true);
      valid = false;
    }
    //principal contact
    if (principleObj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (principleObj.LastName.trim() === "") {
      setlastname(true);
    }
    if (principleObj.EmailAddress.trim() === "") {
      setEmail(true);
    }
    if (principleObj.ConfirmEmail.trim() === "") {
      setConfrimEmail(true);
    }
    if (principleObj.PhoneNumber.trim() === "") {
      setPhonenNumber(true);
    }
    //principal contact

    //compnay details validation end

    var temp = [];
    console.log(directorOne);
    console.log(directorTwo);

    var tempPayment = [Obj, ObjEUR];

    KYCFormView.companyDetail.RestaurantId = dataRows.restaurantRegistrationId;
    KYCFormView.companyDetail.UserId = dataRows.userId;
    KYCFormView.companyDetail.CompanyRegistrationNumber =
      dataRows.companyRegistrationNumber;
    KYCFormView.companyDetail.TypeOfBusinessId = dataRows.businessTypeId;

    KYCFormView.PrincipleContacts = principleObj;
    if (selectedDate != null) {
      KYCFormView.companyDetail.IncorporationDate = mydate;
    }

    if (isOwnAllDomain === "Yes") {
      KYCFormView.companyDetail.IsAllDomainOwn = true;
    } else {
      KYCFormView.companyDetail.IsAllDomainOwn = false;
    }
    if (stockradiovalue === "Yes") {
      KYCFormView.companyDetail.IsListedOnStockExchange = true;
    } else {
      KYCFormView.companyDetail.IsListedOnStockExchange = false;
    }
    if (trialradiovalue === "Yes") {
      KYCFormView.companyDetail.IsOfferTrailPeriods = true;
    } else {
      KYCFormView.companyDetail.IsOfferTrailPeriods = false;
    }
    if (profitradiovalue === "Yes") {
      KYCFormView.companyDetail.IsNotForProfitOrg = true;
    } else {
      KYCFormView.companyDetail.IsNotForProfitOrg = false;
    }
    if (radiovalue === "Yes") {
      KYCFormView.companyDetail.HasRecurringPaymentsOffer = true;
    } else {
      KYCFormView.companyDetail.HasRecurringPaymentsOffer = false;
    }
    console.log(tableData[0].File);
    if (
      tableData[0].File.length == 0 ||
      tableData[1].File.length == 0 ||
      tableData[3].File.length == 0 ||
      kitchenRegistered == false
    ) {
      valid = false;
      toast.error("Validation error on Documents", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    console.log(KYCFormView);
    var compnayDetailsId = "";
    if (valid) {
      console.log("kyc valid");

      //SetloadingModal(true);
      axios({
        method: "post",
        url: apiAddress + "/api/KYCForm/postHomeCookKycForm",
        data: KYCFormView,
      })
        .then(async (response) => {
          console.log(response);
          compnayDetailsId = response.data.companyDetail.Id;

          const dt = await fileupload(compnayDetailsId);
          const dt2 = await test(tableData);
          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          localStorage.removeItem("gotasteadmintoken");
          localStorage.removeItem("restaurant");
          window.location.href = `/`;
        })
        .catch((error) => {
          console.log(error);
          toast.error("Error" + error, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }

    var data = "";
  };

  const [menuSelection, setMenu] = useState(1);

  const [Tabvalue, setTabValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newTabValue: string) => {
    setTabValue(newTabValue);
  };

  const [legalName, setLegalName] = useState("");
  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  const [isValidEmail, setIsValidEmail] = useState(false);
  const validateEmail = (props) => {
    // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    setIsValidEmail(!emailPattern.test(props));

    return emailPattern.test(props);
  };
  const gridSectionSx = {
    px: { xs: 1, sm: 2, md: 4, lg: 6, xl: 10 },
    pt: { xs: 1, md: 2 },
  };

  return (
    <div className="home-cook-kyc-form">
      <div
        className={`home-cook-kyc-form__logout ${props.from == "fillup" ? "d-none" : "d-flex"} `}
      >
        <button
          className="btn btn-success"
          style={{ marginRight: "1rem", cursor: "pointer" }}
          onClick={() => {
            localStorage.removeItem("gotasteadmintoken");
            localStorage.removeItem("permissions");
            window.location.href = `/`;
          }}
        >
          Log Out
        </button>
      </div>
      <div className="home-cook-kyc-form__layout d-flex flex-column flex-md-row">
        <div
          className={`home-cook-kyc-form__sidebar ${props.from == "fillup" ? "d-none" : ""}`}
        >
          <div className="searchBoxForProduct" style={{ padding: "10px" }}>
            {/* <TextAreaComponents label={"Search"} id={4} /> */}
            <input
              type="text"
              placeholder="Search"
              className="form-control searchBar"
            />
          </div>

          <div className="scrollable-div">
            <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b> Form</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} />
            <div
              className={`kyc_form__menuItem ${menuSelection == 1 ? "active" : ""}`}
              style={{
                width: "100%",
                height: "3rem",
                transition: "background-color 0.3s",
              }}
              onClick={() => setMenu(1)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-3"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={fromImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  Fill Up KYC Form
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`home-cook-kyc-form__content p-3 p-md-5 ${menuSelection == 1 ? "" : "d-none"}`}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <ToastContainer />
          <div className="Kyctabview">
            <TabContext value={Tabvalue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleChange} variant="scrollable" scrollButtons="auto">
                  <Tab label="MAF form" value="1" />
                  <Tab label="Documents" value="2" />
                </TabList>
              </Box>
            </TabContext>
            <div className={`${Tabvalue == "1" ? "p-3 kycform " : "d-none"} `}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ flexDirection: "column" }}
              >
                <h3 className="headerName">Go Taste</h3>
                <h3 className="headerName">Home Cook Application Form</h3>
              </div>
              <div className="p-3"></div>
              {/*Started  Applying Company div */}
              {/* <div className="d-flex align-items-center justify-content-between">
                <h3 className="headerName" style={{ fontSize: "1.8rem" }}>
                  {" "}
                  Applying Company{" "}
                </h3>
              </div> */}
              <Grid container spacing={{ xs: 2, md: 3 }} sx={gridSectionSx}>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Trading As*"}
                    value={(props) => {
                      KYCFormView.companyDetail.TradeName = props;
                      setTradename(false);
                    }}
                    error={Tradename}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Registration country*"}
                    value={(props) => {
                      KYCFormView.companyDetail.RegisteredCountry = props;
                      setRegisteredCountry(false);
                    }}
                    error={RegisteredCountry}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={" Company registration number"}
                    value={textFieldValue}
                    val={dataRows.companyRegistrationNumber}
                    id={7}
                  ></TextAreaComponents>
                </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"State*"}
                    value={(props) => {
                      KYCFormView.companyDetail.State = props;
                      setState(false);
                    }}
                    error={State}
                    id={6}
                  ></TextAreaComponents>
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"City*"}
                    value={(props) => {
                      KYCFormView.companyDetail.City = props;
                      setCity(false);
                    }}
                    error={City}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Type of business*"}
                    value={textFieldValue}
                    val={dataRows.businessTypeDetails}
                    id={7}
                  ></TextAreaComponents>
                </Grid> */}

                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "64px", // increase height
                        backgroundColor: "#f3f4f6", // grey background
                        border: "none"
                      },
                      "& fieldset": {
                        border: "none",
                      },
                    }}>
                    <InputLabel id="business-type-label">Type of Business*</InputLabel>
                    <Select
                      labelId="business-type-label"
                      id="business-type"
                      value={dataRows.businessTypeDetails || ""}
                      label="Type of Business*"
                      onChange={(e) =>
                        setDataRows({
                          ...dataRows,
                          businessTypeDetails: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="Sole Trader">Sole Trader</MenuItem>
                      <MenuItem value="Limited Company">Limited Company</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Registered street address*"}
                    value={(props) => {
                      KYCFormView.companyDetail.RegisteredStreetAddress = props;
                      setRegisteredStreet(false);
                    }}
                    error={ReegisteredStreet}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"House number*"}
                    value={(props) => {
                      KYCFormView.companyDetail.HouseNumber = props;
                      setHouseNumber(false);
                    }}
                    error={houseNumber}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Phone number*"}
                    value={(props) => {
                      KYCFormView.companyDetail.PhoneNumber = props;
                      setCompanyDetailsPhone(false);
                    }}
                    error={companyDetailsPhone}
                    id={12}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Postal code* / Zip code*"}
                    value={(props) => {
                      KYCFormView.companyDetail.Postalcode = props;
                      setZipCode(false);
                    }}
                    error={ZipCode}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    sx={{ width: "100%", padding: "0" }}
                  >
                    <DemoContainer
                      components={["DatePicker"]}
                      sx={{ width: "100%", padding: "0" }}
                    >
                      <DatePicker
                        label="Incorporation Date"
                        sx={{ width: "100%", padding: "0" }}
                        onChange={(newValue) => setValue(newValue)}
                        className="custom-textField custom-DateField"
                        maxDate={dayjs(new Date())}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={
                      "Billing address (if differ from registered address)"
                    }
                    value={(props) => {
                      KYCFormView.companyDetail.BillingAddress = props;
                      setBiilingAddress(false);
                    }}
                    error={BiilingAddress}
                    id={6}
                  ></TextAreaComponents>
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Country Code*"}
                    value={(props) => {
                      KYCFormView.companyDetail.CountryCode = props;
                      setCountryCode(false);
                    }}
                    error={CountryCode}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              {/*Ending  Applying Company div */}
              <div
                className="d-flex align-items-center"
                style={{ gap: "10px", marginTop: "2rem" }}
              >
                <h3 className="headerName">Principal Contact *</h3>
              </div>

              <Grid container spacing={{ xs: 2, md: 3 }} sx={gridSectionSx}>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"First name"}
                    value={(props) => {
                      principleObj.FirstName = props;
                      setFirstName(false);
                    }}
                    error={FirstName}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Last name "}
                    value={(props) => {
                      principleObj.LastName = props;
                      setlastname(false);
                    }}
                    error={lastname}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Email address"}
                    value={(props) => {
                      principleObj.EmailAddress = props;
                      setEmail(false);
                      validateEmail(principleObj.EmailAddress);
                    }}
                    isValid={isValidEmail}
                    error={Email}
                    id={6}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Confirm email address"}
                    value={(props) => {
                      principleObj.ConfirmEmail = props;
                      setConfrimEmail(false);
                    }}
                    error={ConfirmEmail}
                    id={14}
                  ></TextAreaComponents>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextAreaComponents
                    label={"Phone number"}
                    value={(props) => {
                      principleObj.PhoneNumber = props;
                      setPhonenNumber(false);
                    }}
                    error={PhonenNumber}
                    id={12}
                  ></TextAreaComponents>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div className="d-flex justify-content-end flex-wrap gap-2">
                    <Button
                      className="btn-custom-submit"
                      onClick={() => {
                        setTabValue("2");
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className={`${Tabvalue == "2" ? "" : "d-none"}`}>
              <DocumentsUpload parentData={dataFromDocument} />
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div className="d-flex justify-content-end flex-wrap gap-2">
                    <Button
                      className="btn-custom-submit"
                      onClick={() => {
                        setTabValue("1");
                      }}
                    >
                      Previous
                    </Button>
                    <Button
                      className="btn-custom-submit"
                      onClick={() => {
                        submitData();
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeCookKYCForm;
